import { useEffect } from "react";
import { useBlocker } from "react-router";

import { requestConfigurationNavigation } from "./navigation";

/** Data-router navigation (including Back) defers to the currently mounted editor. */
export function ConfigurationNavigationGuard() {
	const blocker = useBlocker(
		({ currentLocation, nextLocation }) =>
			currentLocation.pathname !== nextLocation.pathname ||
			currentLocation.search !== nextLocation.search,
	);
	useEffect(() => {
		if (blocker.state === "blocked")
			requestConfigurationNavigation(blocker.proceed, blocker.reset);
	}, [blocker]);
	return null;
}
